import { FormAction } from "../form-action";
export default {
    action: {
        [FormAction.AdjustParticipant]: '加签',
        [FormAction.Agree]: '同意',
        [FormAction.DisAgree]: '不同意',
        [FormAction.Assist]: '协办',
        [FormAction.Cancel]: '作废',
        [FormAction.Circulate]: '传阅',
        [FormAction.Delete]: '删除',
        [FormAction.Edit]: '编辑',
        [FormAction.FinishInstance]: '结束',
        [FormAction.Forward]: '转办',
        [FormAction.Print]: '打印',
        [FormAction.Reject]: '驳回',
        [FormAction.Retrieve]: '撤回',
        [FormAction.Save]: '暂存',
        [FormAction.Submit]: '提交',
        [FormAction.Urge]: '催办',
        more: '更多',
        save2: '保存',
        cancel2: '取消'
    },
    actionTip: {
        [FormAction.AdjustParticipant]: '加签成功！',
        [FormAction.Agree]: '操作成功！',
        [FormAction.DisAgree]: '操作成功！',
        [FormAction.Assist]: '协办成功！',
        [FormAction.Cancel]: '操作成功！',
        [FormAction.Circulate]: '传阅成功！',
        [FormAction.Delete]: '删除成功！',
        [FormAction.FinishInstance]: '结束流程成功！',
        [FormAction.Forward]: '转办成功！',
        [FormAction.Reject]: '驳回成功！',
        [FormAction.Retrieve]: '撤回成功！',
        [FormAction.Save]: '暂存成功！',
        [FormAction.Submit]: '提交成功！',
        [FormAction.Urge]: '发送成功！',
        save2: '保存成功！'
    },
    tip: {
        [FormAction.Cancel]: '作废后该流程将停止流转，确定要作废？',
        [FormAction.Delete]: '数据删除后不能恢复，确定要删除？',
        [FormAction.FinishInstance]: '确定立即结束流程？',
        [FormAction.Retrieve]: '确定要撤回吗？',
        saveSuccess: '暂存成功',
        deleteSuccess: '删除成功',
        retrieveSuccess: '撤回成功',
        rejectSuccess: '驳回成功',
        errTips1: '不允许转办给自己！',
        errTips2: '不允许加签给自己！',
        errTips3: '不能协办给当前活动处理人',
        errTips4: '数据模型不存在！',
        errTips5: '数据模型编码无效！',
        errTips6: '{msg}，请联系系统管理员！',
        errTips7: '业务对象不存在！',
        errTips8: '流程实例已被删除！',
        errTips9: '当前任务已被取消或者已被处理！',
        errTips10: '当前任务不能被撤回！',
        errTips11: '检测到有参与者参与过当前节点，不能再处理当前节点的任务！',
        errTips12: '不允许调整给自己！',
    },
    modal: {
        selectUser: '选择{text}人员',
        pleaseSelectUser: '请选择{text}人员',
        explain: '{text}说明',
        pleaseInputExplain: '请输入{text}说明',
        pleaseInput: '请输入',
        pleaseChoose: '请选择',
        reject: '驳回到',
        rejectTips: "请选择驳回到",
        reSubmitTip: '重新提交后回到当前节点',
        selectOrg: '选择所属部门',
        pleaseInputOpinion: '请输入审批意见',
        pleaseAddSign: '请添加手写签名',
        noRejectNode: '没有可驳回的节点',
    },
    biz: {
        systemValue: '系统自动填充',
        index: '序号',
        add: '新建',
        delete: '删除',
        action: '操作',
        importData: '导入数据',
        importTips1: '为确保上传数据与列表内容匹配，请先',
        importTips2: '下载示例文件',
        importLocalFaile: '导入本地文件',
        selectLocalFaile: '选择本地文件',
        importTips3: '支持csv /xls格式，文件大小不限，一次最多能导入500条',
        cancel: '取消',
        clear: '清空',
        startImport: '开始导入',
        ok: '确定',
        reImport: '重新导入',
        importing: '导入中',
        importTips4: '导入数据过程中请不要关闭页面，避免导入错误',
        import: '导入',
        export: '导出',
        fullScreen: '全屏',
        smallScreen: '小屏',
        importFormRelevanceForm: '从关联表单导入',
        addMethod: '新增方式'
    },
    urge: {
        check: '查看',
        urgeRecord: '催办记录',
        urgeContent: '催办内容',
        loadAll: '已加载全部记录',
        plzInput: '请输入',
        urgeSuccess: '催办成功！',
        urgeFailed: '催办失败，请重新尝试！',
        cantUrgeSelf: '当前处理人是你自己，不能催办自己',
        netError: '网络错误'
    }
};
